import type { Directive } from "vue";

export const outside: Directive = {
  beforeMount(el, binding) {
    el.clickOutsideEvent = (event: MouseEvent) => {
      // 如果点击目标在绑定元素内，则忽略
      if (el === event.target || el.contains(event.target)) return;
      // 如果点击目标在弹窗 Teleport 出来的内容内（例如 .el-popper），也忽略
      if (event.target && (event.target as HTMLElement).closest(".el-popper"))
        return;

      // 否则触发回调
      binding.value(event);
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
};
